import React, { useState } from "react";
import { Form, Input, Row, Col, Button, Tabs } from "antd";
import { toast } from "react-toastify";
import { postRequest } from "../../api/http";
import userServiceApi from "../../api/userServiceApi";
import { LoadingView } from "../../common";
import Logo from "../../../src/assets/images/PoweredNew.png";
import { useNavigate } from "react-router-dom";
import backBtn from "../../assets/images/back-arrow.svg";
import poweredLogo from "../../../src/assets/images/PoweredNew.png";
import leftArrow from "../../../src/assets/images/LeftArrow.svg";
import "./Login.scss";
import { inputFieldCharLimit } from "../../config";

export default function ForgotPasswordForm() {
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const navigate = useNavigate();

  const onFinish = async (values) => {
    const payload = {
      ...values,
      userRole: 'PARTNER_ADMIN'
    }
    setLoading(true);
    try {
      const response = await postRequest(
        userServiceApi.forgotPassword(),
        payload
      );
      if (response === "success") {
        toast.success("Reset link has been sent to your mail");
        setLoading(false);
        navigate("/PartnerAdmin");
      } else {
        setLoading(false);
      }
    } catch (error) {
      toast.error(error.message);
      setLoading(false);
    }
  };
  const onFinishFailed = (errorInfo) => {
    console.error("Failed:", errorInfo);
  };

  return (
    <>
    <div className="changepassword-page">
        <div className="header-container">
          <div className="partner-header">
            <div
              className="heading-backBtn"
              onClick={() => {
                navigate("/PartnerAdmin");
              }}
            >
              <img src={leftArrow} alt="leftarrow" />
              <p>Reset password</p>
            </div>
          </div>
        </div>


        <div className="changePwdContainer custom">
          <div className="forgotPassword">
            <Form
              form={form}
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              autoComplete="off"
              layout="vertical"
            >
            
              <div className="forgotPasswordForm">
                <div className="formRow">
                  <div className="formCol">
                    <Form.Item
                      label="Email"
                      name="email"
                      normalize={(value) => value?.trim()}
                      rules={[{ required: true, message: "Email is required" }]}
                    >
                      <Input placeholder="Email" />
                    </Form.Item>
                  </div>
                  <div className="formCol">
                    <Button
                      className="cancelBtn"
                      onClick={() => {
                        navigate(`/PartnerAdmin`);
                      }}
                    >
                      Cancel
                    </Button>
                    <Button className="redBtn" htmlType="submit">
                      Request Reset Password
                    </Button>
                    
                  </div>
                  <div className="formCol"></div>
                </div>
              </div>

            </Form>
          </div>
          <div className="footerlogo">
            <img
              style={{ cursor: "pointer", width: "100px", marginTop: "15px" }}
              src={Logo}
              alt=""
            />
          </div>
        </div>
      </div>
    </>
  );
}
